import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderService } from 'src/app/loader.service';
import { StationService } from 'src/app/_services/station.service';
import { TableBtn, TableColumn } from 'src/app/shared/interfaces';
import { Subscription } from 'rxjs';
import { ExportCSVService } from 'src/app/_services/export-csv.service';
import { MatDialog } from '@angular/material/dialog';
import { SnackbarService } from '../../_service/message-service';
import { TranslateService } from '@ngx-translate/core';

export interface referralsData {
  userId: number;
  userName: string;
  referMobile: string;
  referEmail: string;
  createdDate: string;
  enable: string;
  toFriend: string;
  senderType: string;
  no: number;
}
@Component({
  selector: 'telio-refer-afriend',
  templateUrl: './refer-afriend.component.html',
  styleUrls: ['./refer-afriend.component.scss']
})
export class ReferAfriendComponent implements OnInit {
  referralsData: referralsData[];
  columns: TableColumn[];
  buttons: TableBtn[];
  filterPlaceholder: string = '';
  actionHeader: string = '';
  subscription: Subscription = new Subscription;

  initialData: any;
  pageList = {
    currentPage: 0,
    pageSize: 10
  };
  currentPage = 0;
  totalDataCount = 0;
  sortColumn = '';
  sortDirection = 'asc';

  constructor(private stationService: StationService,
    readonly exportCSVService: ExportCSVService,
    public translate: TranslateService,
    private toastr: SnackbarService, public dialog: MatDialog,
    public loaderService: LoaderService) {
    this.rerender(this.pageList, '')

    this.columns = [
      { columnDef: 'createdDate', header: 'referFriend.date', cell: (element: referralsData) => `${element.createdDate}`, sortingDisabled: false, width: '100px' },
      { columnDef: 'userId', header: 'referFriend.userId', cell: (element: referralsData) => `${element.userId}`, sortingDisabled: false, width: '50px' },
      { columnDef: 'userName', header: 'referFriend.userName', cell: (element: referralsData) => `${element.userName}`, sortingDisabled: false, width: '100px' },
      { columnDef: 'toFriend', header: 'referFriend.referMobile', cell: (element: referralsData) => `${element.referMobile}`, sortingDisabled: false, width: '70px' },
      { columnDef: 'referEmail', header: 'referFriend.referEmail', cell: (element: referralsData) => `${element.referEmail}`, sortingDisabled: true, width: '120px' },
    ];
    this.actionHeader = 'referFriend.actions';
    this.filterPlaceholder = 'generalTable.filterPlaceholder';
  }

  ngOnInit(): void { }
  rerender(value: any, searchFilter?: string) {
    this.getReferalList(value, searchFilter);
  }
  applyFilter(filteredData: string) {
    this.rerender(this.pageList, filteredData)
  }
  getReferalList(value: any, searchFilter: string = '') {
    this.subscription.add(this.stationService.getAllReferrals(value.currentPage + 1, value.pageSize, this.sortColumn, this.sortDirection, searchFilter).subscribe((res: any) => {
      this.referralsData = res.data;
      this.totalDataCount = res.totalItems;
      this.setReferMap(this.referralsData)
    }, err => {
      this.toastr.error(this.translate.instant('responseFailed'));
    }));
  }
  //csv download
  actionCSV() {
    const options = {
      filename: this.translate.instant('referFriend.ReferFriendfileName'),
      showTitle: false,
      title: this.translate.instant('referFriend.ReferFriendfileName'),
      useKeysAsHeaders: true,
    }
    this.subscription.add(this.stationService.getAllReferrals(1, this.totalDataCount, this.sortColumn, 'asc', '').subscribe((res: any) => {
      this.initialData = res.data;
      this.setReferMap(this.initialData)
      this.exportCSVService.exportCSV(options, this.initialData);
    }));
  }

  //reload
  actionClick() {
    this.rerender(this.pageList);
  }

  dateTransformCreatedDate(date: string) {
    let dateIn: Date = new Date(date);
    dateIn.setHours(dateIn.getHours() + 5);
    dateIn.setMinutes(dateIn.getMinutes() + 30);
    let dateOut = dateIn.toISOString().replace("T", " ").substring(0, 10);
    return dateOut;
  }
  getEmail(toFriend: string) {
    const modifiedReferralsData = [];
    const toFriendValues = [];
    for (let i = 0; i < this.referralsData.length; i++) {
      this.referralsData[i]['referEmail'] = '';
      this.referralsData[i]['referMobile'] = '';
      if (this.referralsData[i].senderType == 'EMAIL') {
        this.referralsData[i].referEmail = this.referralsData[i].toFriend;
      }
      if (this.referralsData[i].senderType == 'MOBILE') {
        this.referralsData[i].referMobile = this.referralsData[i].toFriend;
      }
      modifiedReferralsData.push(this.referralsData[i]);
      toFriendValues.push(this.referralsData[i].toFriend);
    }
    return { modifiedReferralsData, toFriendValues };
  }
  loadData(value: any) {
    let val = {
      currentPage: value.currentPage,
      pageSize: value.pageSize
    }
    this.pageList.pageSize = value.pageSize;
    this.rerender(val, '')
  }
  sortClick(event: any) {
    this.sortColumn = event.active;
    this.sortDirection = event.direction;
    this.rerender(this.pageList, '');
  }

  setReferMap(data) {
    data.map((item: any, i: number) => {
      let empty = 'NA';
      const { toFriendValues } = this.getEmail(item.toFriend);
      item.userId = !item.userId ? empty : item.userId;
      item.createdDate = !item.createdDate ? empty : this.dateTransformCreatedDate(item.createdDate);
      item.userName = !item.userName ? empty : item.userName;
      item.referMobile = item.senderType == 'MOBILE' ? (!item.toFriend ? empty : item.toFriend) : empty;
      item.referEmail = item.senderType == 'EMAIL' ? (!item.toFriend ? empty : item.toFriend) : empty;
    });
  }
}


